// utils/dayjs.config.ts
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

import 'dayjs/locale/pt-br';
import 'dayjs/locale/en';
import i18n from '../i18n';

const localeMap: Record<string, string> = {
  'pt-BR': 'pt-br',
  'pt-PT': 'pt',
  'en-US': 'en',
};

// define o idioma atual
dayjs.locale(localeMap[i18n.language] || 'pt-br');

// atualiza quando o idioma mudar
i18n.on('languageChanged', lng => {
  dayjs.locale(localeMap[lng] || 'pt-br');
});

export default dayjs;
